import styled from 'styled-components'

export const NavigationList = styled.ul<{level: number; itemCount: number}>`
  margin: 0;
  padding: 0;

  ${({level}): string => (level === 0 ? 'display: block;' : 'display: none;')}
  .open > & {
    display: block;
  }
`
